import { ActivatedRoute } from '@angular/router';
import { ModuleInformation } from './../../../models/module-information';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { RecordsListComponent } from './../../records-list/records-list.component';
import { Component } from '@angular/core';
import { Field } from '../../field';
import { LayoutService } from '../../layout.service';
// import * as ModuleStructure from 'src/app/models/module-structure';
import { RecordListDrawerArgs } from 'src/app/models/record-list-drawer-args';
import { RecordPageComponent } from '../../record-page/record-page.component';
import { GlobalObject } from 'src/app/models/business/global-object';
// import { faAsterisk } from '@fortawesome/free-solid-svg-icons';
import {
  FieldDataType,
  Field as ModuleField,
} from '@app/models/module-structure';
import * as moment from 'moment';
import * as g from '@app/globals';
import { ModuleHeaderDataPayload } from '@app/models/module-header-data-payload';
import { tap, switchMap } from 'rxjs/operators';

import * as serviceCall from '@app/models/business/ServiceCall';
import { RecordLine } from '@app/layout/record-model';
import { BillOfMaterials } from '@app/models/business/billOfMaterials';
import { BillOfMaterialService } from '@app/services/BillOfMaterial.service';
import { of } from 'rxjs';
import { NzAutocompleteOptionComponent } from 'ng-zorro-antd/auto-complete';
import { LineSectionComponent } from '@app/layout/sections/line-section/line-section.component';
import { ViewContainerRef, Injector } from '@angular/core';
@Component({
  selector: 'app-input-link',
  templateUrl: './input-link.component.html',
  styleUrls: ['./input-link.component.less'],
})
export class InputLinkComponent extends Field {
  searchDrawerVisible = false;
  selectedRecords: string[] = [];
  isSelectButtonLoading = false;
  creationInsideShowHide = false;
  creationInsideModule = '';
  lastCheckedValue = '';

  options: { value: string | number; label: string }[] = [];
  term = '';
  loadingDropDownMenu: boolean;
  moduleInformation: ModuleInformation;
  validateClicked = false;
  parent: LineSectionComponent;

  constructor(
    public layoutService: LayoutService,
    private drawerService: NzDrawerService,
    private route: ActivatedRoute,
    private bomService: BillOfMaterialService,
    private viewContainerRef: ViewContainerRef,
  ) {
    super(layoutService);
    this.parent = this.viewContainerRef.injector.get(
      LineSectionComponent,
      null,
    );
  }

  initField() {
    if (
      this.recordProperty &&
      this.recordProperty.ValidateValueForLinkedValue
    ) {
      this.recordProperty.ValidateValueForLinkedValue = false;
      this.validateSelection();
    }
  }

  selectionChangedFromAutoComplete($event: NzAutocompleteOptionComponent) {
    if ($event.nzValue === this.lastCheckedValue) {
      return;
    } else {
      this.recordProperty.ValueAsObject = $event.nzValue;
      this.validateSelection();
    }
  }

  getLinkedModuleInfo(): { IsById: boolean; LinkedModule: string } {
    if (this.field.LinkedModule.substring(0, 2) === '{#') {
      const linkedModuleElm = this.field.LinkedModule.substring(2)
        .slice(0, -1)
        .split(';');
      const moduleNameCatgName = linkedModuleElm[0].split('.');
      let currentLine = this.recordModel.Categories.find(
        (c) => c.Id === moduleNameCatgName[0],
      ).Lines[this.lineId];

      if (currentLine == null || currentLine === undefined) {
        currentLine = this.recordModel.Categories.find(
          (c) => c.Id === moduleNameCatgName[0],
        ).Lines.find((l) => l.Id == this.lineId);
      }
      const linkedModuleObj = currentLine.Properties.find(
        (p) => p.Name === moduleNameCatgName[1],
      );

      if (linkedModuleElm[2] === 'DBValue') {
        const linkedModule = linkedModuleObj.DBValue;
        if (linkedModuleElm[1].toString() === 'TypeId') {
          if (linkedModule === '') {
            return {
              IsById: true,
              LinkedModule: linkedModuleObj.ValueAsObject,
            };
          } else {
            return { IsById: true, LinkedModule: linkedModule };
          }
        }
      } else {
        const valueAsString = linkedModuleObj.ValueAsObject as string;
        if (valueAsString.indexOf('|--') !== 0) {
          let objectType;
          objectType = valueAsString.split('|');
          objectType = objectType[0];
          return { IsById: true, LinkedModule: objectType };
        } else {
          return { IsById: false, LinkedModule: linkedModuleObj.ValueAsObject };
        }
      }
    } else {
      return { IsById: false, LinkedModule: this.field.LinkedModule };
    }
  }

  triggerMenu(newValue) {
    if (newValue) {
      this.loadingDropDownMenu = true;
      const linkedModuleInfo = this.getLinkedModuleInfo();

      if (linkedModuleInfo.IsById) {
        this.layoutService
          .moduleIdByType(
            linkedModuleInfo.LinkedModule,
            this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
          )
          .subscribe((d) => {
            const moduleId = d.toString();
            this.layoutService
              .moduleInformation(moduleId)
              .subscribe((moduleInformation: ModuleInformation) => {
                this.moduleInformation = moduleInformation;
                this.loadingDropDownMenu = false;
              });
          });
      } else {
        const moduleId = linkedModuleInfo.LinkedModule;
        this.layoutService
          .moduleInformation(moduleId)
          .subscribe((d: ModuleInformation) => {
            this.moduleInformation = d;
            this.loadingDropDownMenu = false;
          });
      }
    }
  }

  async openSearchDrawer() {
    this.searchDrawerVisible = true;
    const linkedModuleInfo = this.getLinkedModuleInfo();

    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          this.executeOpenSearchDrawer(d.toString());
        });
    } else {
      this.executeOpenSearchDrawer(linkedModuleInfo.LinkedModule);
    }
  }

  openCreationInside() {
    const parentComponent = this;
    const linkedModuleInfo = this.getLinkedModuleInfo();

    if (this.moduleStructure.module.ObjectType === 'oSalesOpportunity') {
    }

    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          linkedModuleInfo.LinkedModule = d.toString();
          this.creationInsideModule = linkedModuleInfo.LinkedModule;
          this.creationInsideShowHide = !this.creationInsideShowHide;
          const record = this.recordModel;
          let cardCode = '';
          const documentCat = this.recordModel.Categories.find(
            (cat) => cat.Id === 'SalesOpportunities',
          );
          if (documentCat !== undefined && documentCat != null) {
            cardCode = documentCat.Lines[0].Properties.find(
              (prop) => prop.Name === 'CardCode',
            )?.ValueAsObject;
            if (cardCode == null || cardCode === undefined) {
              cardCode = '';
            }
          }

          RecordPageComponent.openRecordPage(this.drawerService, {
            actionType: 'Add',
            drawerTitle: 'Create',
            inDrawer: true,
            moduleId: Number(linkedModuleInfo.LinkedModule),
            parentComponent,
            recordId: undefined,
            recordModel: undefined,
            parentRecordModel: this.recordModel,
            inputValues:
              cardCode !== '' ? { 'Documents.CardCode': cardCode } : undefined,
          });
        });
    } else {
      this.creationInsideModule = linkedModuleInfo.LinkedModule;
      this.creationInsideShowHide = !this.creationInsideShowHide;
      const record = this.recordModel;
      let cardCode = '';
      const documentCat = this.recordModel.Categories.find(
        (cat) => cat.Id === 'SalesOpportunities',
      );
      if (documentCat !== undefined && documentCat != null) {
        cardCode = documentCat.Lines[0].Properties.find(
          (prop) => prop.Name === 'CardCode',
        )?.ValueAsObject;
        if (cardCode == null || cardCode === undefined) {
          cardCode = '';
        }
      }
      if (
        linkedModuleInfo.LinkedModule === '25' &&
        this.recordModel.ObjectTypeValue === '191'
      ) {
        cardCode = this.recordModel.Categories.find(
          (x) => x.Id === 'ServiceCalls',
        ).Lines[0].Properties.find(
          (x) => x.Name === 'CustomerCode',
        ).ValueAsObject;
      }
      RecordPageComponent.openRecordPage(this.drawerService, {
        actionType: 'Add',
        drawerTitle: 'Create',
        inDrawer: true,
        moduleId: Number(linkedModuleInfo.LinkedModule),
        parentComponent,
        recordId: undefined,
        recordModel: undefined,
        parentRecordModel: this.recordModel,
        inputValues:
          cardCode !== ''
            ? linkedModuleInfo.LinkedModule === '25'
              ? { 'Contacts.CardCode': cardCode }
              : { 'Documents.CardCode': cardCode }
            : undefined,
      });
    }

    // this.layoutService.getModuleHeaderData(this.creationInsideModule,)
  }

  linkedObjectSubmitted($event) {
    this.objectSubmitted($event);
  }

  objectSubmitted($event) {
    this.selectedRecords.push($event);
    this.creationInsideShowHide = false;
    this.submitSelection(false);
  }

  openView() {
    console.log('xxx');
    if (this.recordProperty.ValueAsObject?.toString() === '') {
      return;
    }

    const linkedModuleInfo = this.getLinkedModuleInfo();
    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          linkedModuleInfo.LinkedModule = d.toString();
          let recordEntry = this.recordProperty.ValueAsObject;
          if (
            this.recordModel.ObjectKey === 'oContacts' &&
            this.recordProperty.Name === 'DocNum'
          ) {
            recordEntry = this.recordCategory.Lines[0].Properties.find(
              (p) => p.Name === 'DocEntry',
            ).ValueAsObject;
          }
          if (
            this.recordModel.ObjectKey === 'oSalesOpportunities' &&
            this.recordProperty.Name === 'RealDocumentNumber'
          ) {
            recordEntry = this.recordLine.Properties.find(
              (p) => p.Name === 'DocumentNumber',
            ).ValueAsObject;
          }
          if (
            this.recordModel.ObjectKey === 'oSalesOpportunities' &&
            this.recordProperty.Name === 'DocNum'
          ) {
            recordEntry = this.recordLine.Properties.find(
              (p) => p.Name === 'U_Quote',
            ).ValueAsObject;
          }
          if (
            this.recordModel.ObjectKey === 'oOrders' &&
            this.recordProperty.Name === 'RefDocNum'
          ) {
            recordEntry = this.recordLine.Properties.find(
              (p) => p.Name === 'RefDocEntr',
            ).ValueAsObject;
          }
          if (
            this.recordModel.ObjectKey === 'oSalesOpportunities' &&
            this.recordProperty.Name === 'LinkedDocumentNo'
          ) {
            recordEntry = this.recordLine.Properties.find(
              (p) => p.Name === 'LinkedDocumentNumber',
            ).ValueAsObject;
          }
          if (
            this.recordModel.ObjectKey === 'oProductionOrders' &&
            this.recordProperty.Name === 'OriginNum'
          ) {
            recordEntry = this.recordLine.Properties.find(
              (p) => p.Name === 'OriginAbs',
            ).ValueAsObject;
          }
          RecordPageComponent.openRecordPage(this.drawerService, {
            actionType: 'View',
            drawerTitle: 'View Details',
            inDrawer: true,
            moduleId: Number(linkedModuleInfo.LinkedModule),
            parentComponent: this,
            recordId: recordEntry,
            recordModel: undefined,
            linkedField:
              Number(linkedModuleInfo.LinkedModule) === 89
                ? this.field.LinkedField
                : '',
          });
        });
    } else {
      let recordEntry = this.recordProperty.ValueAsObject;
      if (
        this.recordModel.ObjectKey === 'oContacts' &&
        this.recordProperty.Name === 'DocNum'
      ) {
        recordEntry = this.recordCategory.Lines[0].Properties.find(
          (p) => p.Name === 'DocEntry',
        ).ValueAsObject;
      }
      if (
        this.recordModel.ObjectKey === 'oSalesOpportunities' &&
        this.recordProperty.Name === 'RealDocumentNumber'
      ) {
        recordEntry = this.recordLine.Properties.find(
          (p) => p.Name === 'DocumentNumber',
        ).ValueAsObject;
      }
      if (
            this.recordModel.ObjectKey === 'oSalesOpportunities' &&
            this.recordProperty.Name === 'DocNum'
          ) {
            recordEntry = this.recordLine.Properties.find(
              (p) => p.Name === 'U_Quote',
            ).ValueAsObject;
          }
      if (
        this.recordModel.ObjectKey === 'oOrders' &&
        this.recordProperty.Name === 'RefDocNum'
      ) {
        recordEntry = this.recordLine.Properties.find(
          (p) => p.Name === 'RefDocEntr',
        ).ValueAsObject;
      }
      if (
        this.recordModel.ObjectKey === 'oSalesOpportunities' &&
        this.recordProperty.Name === 'LinkedDocumentNo'
      ) {
        recordEntry = this.recordLine.Properties.find(
          (p) => p.Name === 'LinkedDocumentNumber',
        ).ValueAsObject;
      }
      if (
        this.recordModel.ObjectKey === 'oProductionOrders' &&
        this.recordProperty.Name === 'OriginNum'
      ) {
        recordEntry = this.recordLine.Properties.find(
          (p) => p.Name === 'OriginAbs',
        ).ValueAsObject;
      }
      RecordPageComponent.openRecordPage(this.drawerService, {
        actionType: 'View',
        drawerTitle: 'View Details',
        inDrawer: true,
        moduleId: Number(linkedModuleInfo.LinkedModule),
        parentComponent: this,
        recordId: recordEntry,
        recordModel: undefined,
        linkedField:
          Number(linkedModuleInfo.LinkedModule) === 89
            ? this.field.LinkedField
            : '',
      });
    }
  }

  executeOpenSearchDrawer(linkedModule) {
    const args: RecordListDrawerArgs = {
      parentComponent: this,
      moduleId: Number(linkedModule),
      inDrawer: true,
      isSingleSelection:
        this.field.PropertyName === 'ItemCode' && this.section.Type === 2
          ? false
          : true,
      linkedFieldId: this.field.Id,
      linkedFieldSectionTagName: this.sectionTagName,
      term: this.term,
      lineId: this.lineId,
      recordModel: this.recordModel,
      showCheckBoxInTableMode: true,
    };

    RecordsListComponent.openRecordListDrawer(this.drawerService, args);
  }

  selectionChanged(event) {
    this.selectedRecords = event;
  }

  modelChanged(event) {
    if (event === this.lastCheckedValue) {
      return;
    } else {
      this.validateSelection();
    }
  }

  validateSelection() {
    this.lastCheckedValue = this.recordProperty.ValueAsObject;
    this.validateClicked = true;
    const value = this.recordProperty.ValueAsObject;

    const linkedModuleInfo = this.getLinkedModuleInfo();

    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          this.validationSelectionData(d.toString(), value);
        });
    } else {
      this.validationSelectionData(linkedModuleInfo.LinkedModule, value);
    }
  }

  validationSelectionData(linkedField, value) {
    let enableSearchOnPart = false;
    let lengthForSearchOnPart = 0;
    var modulesToCheck = g.enableSearchOnPartForObject.split(',');
    if (modulesToCheck.indexOf(linkedField) !== -1) {
      enableSearchOnPart = true;
      lengthForSearchOnPart = g.lengthForSearchOnPart;
    }

    const body = {
      moduleId: linkedField,
      term: value,
      linkedFieldId: this.field.Id,
      valuesToPass: ModuleField.getValuesToPassBasedOnConditions(
        this.field,
        this.recordModel,
        this.lineId,
        this.sectionTagName,
      ),
    };

    this.layoutService
      .getAutoCompleteValidate(body)
      .subscribe((d: { OneResult: boolean; Value: string }) => {
        if (d.OneResult) {
          this.selectedRecords = [d.Value];
          this.submitSelection(true);
        } else {
          if (enableSearchOnPart) {
            const body1 = {
              moduleId: linkedField,
              term: value.toString().substring(0, lengthForSearchOnPart),
              linkedFieldId: this.field.Id,
              valuesToPass: ModuleField.getValuesToPassBasedOnConditions(
                this.field,
                this.recordModel,
                this.lineId,
                this.sectionTagName,
              ),
            };

            this.layoutService
              .getAutoCompleteValidate(body1)
              .subscribe((d: { OneResult: boolean; Value: string }) => {
                if (d.OneResult) {
                  this.selectedRecords = [d.Value];
                  this.submitSelection(true);
                } else {
                  this.term = this.recordProperty.ValueAsObject;
                  this.recordProperty.ValueAsObject = '';
                  this.openSearchDrawer();
                }
              });
          } else {
            this.term = this.recordProperty.ValueAsObject;
            this.recordProperty.ValueAsObject = '';
            this.openSearchDrawer();
          }
        }
      });
  }

  onType(e: Event): void {
    const value = (e.target as HTMLInputElement).value;
    const linkedModuleInfo = this.getLinkedModuleInfo();

    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          this.onTypeData(d.toString(), value);
        });
    } else {
      this.onTypeData(linkedModuleInfo.LinkedModule, value);
    }
  }

  onTypeData(linkedField, value) {
    let enableSearchOnPart = false;
    let lengthForSearchOnPart = 0;
    var modulesToCheck = g.enableSearchOnPartForObject.split(',');
    if (modulesToCheck.indexOf(linkedField) !== -1) {
      enableSearchOnPart = true;
      lengthForSearchOnPart = g.lengthForSearchOnPart;
    }

    let cardCode = '';
    const documentCat = this.recordModel.Categories.find(
      (cat) => cat.Id === 'SalesOpportunities' || cat.Id === 'Documents',
    );
    if (documentCat !== undefined && documentCat != null) {
      cardCode = documentCat.Lines[0].Properties.find(
        (prop) => prop.Name === 'CardCode',
      )?.ValueAsObject;
      if (cardCode == null || cardCode === undefined) {
        cardCode = '';
      }
    }

    const body = {
      moduleId: linkedField,
      term: value,
      linkedFieldId: this.field.Id,
      cardCode,
      valuesToPass: ModuleField.getValuesToPassBasedOnConditions(
        this.field,
        this.recordModel,
        this.lineId,
        this.sectionTagName,
      ),
    };

    this.layoutService
      .getAutoCompleteType(body)
      .subscribe(
        (d: {
          Count: number;
          Rows: { value: string | number; label: string }[];
        }) => {
          this.options = d.Rows;
          if (this.options.length === 0 && enableSearchOnPart) {
            const body1 = {
              moduleId: linkedField,
              term: value.toString().substring(0, lengthForSearchOnPart),
              linkedFieldId: this.field.Id,
              cardCode,
              valuesToPass: ModuleField.getValuesToPassBasedOnConditions(
                this.field,
                this.recordModel,
                this.lineId,
                this.sectionTagName,
              ),
            };

            this.layoutService
              .getAutoCompleteType(body1)
              .subscribe(
                (d: {
                  Count: number;
                  Rows: { value: string | number; label: string }[];
                }) => {
                  this.options = d.Rows;
                },
              );
          }
        },
      );
  }

  submitSelection(fromTyping: any) {
    const linkedModuleInfo = this.getLinkedModuleInfo();

    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          this.submitSelectionData(d.toString(), fromTyping);
        });
    } else {
      this.submitSelectionData(linkedModuleInfo.LinkedModule, fromTyping);
    }
  }

  submitSelectionData(linkedModule, fromTyping: any) {
    if (this.selectedRecords.length === 0) {
      return;
    } else {
      let maxIndex = 0;
      if (this.selectedRecords.length > 1) {
        const keyPropertyName = this.section.KeyPropertyName;
        const lastLineNum = this.recordCategory.Lines[
          this.recordCategory.Lines.length - 1
        ].Properties.find((p) => p.Name === keyPropertyName);
        if (lastLineNum != null) {
          maxIndex = lastLineNum.ValueAsObject;
        } else {
          maxIndex =
            this.recordCategory.Lines[this.recordCategory.Lines.length - 1].Id;
        }
      }
      let index = 0;
      const field = { ...this.field };
      // if (typeof fromTyping == 'string') {
      //   field.LinkedField = '';
      // }
      const moduleHeaderDataPayload: ModuleHeaderDataPayload[] =
        this.selectedRecords.map((record) => {
          let linkedField = field.LinkedField;
          if (field.LinkedField.startsWith('{')) {
            let linkedFieldObj = JSON.parse(field.LinkedField);
            console.log(linkedFieldObj);
            linkedField = linkedFieldObj[linkedModule];
          }
          return { selectedId: record, linkedField: linkedField };
        });
      let forceToField = '';
      if (this.recordModel.ObjectKey === 'oIncomingPayments') {
        if (field.PropertyName === 'TransferAccount') {
          forceToField = 'TransferAccount';
        } else if (field.PropertyName === 'CashAccount') {
          forceToField = 'CashAccount';
        }
      }

      this.getModuleHeaderDatas(
        linkedModule,
        moduleHeaderDataPayload,
        maxIndex,
        forceToField,
      );

      super.checkWarningOnChange();
    }
  }

  getModuleHeaderDatas(
    linkedModule,
    payload: ModuleHeaderDataPayload[],
    maxIndex: number,
    forceToField: string,
  ) {
    this.layoutService
      .getManyModuleHeaderData(linkedModule, payload)
      .pipe(
        tap((response) => {
          Object.keys(response).forEach((key, index) => {
            const selectedId = key.split('.')[0];
            const linkedField = key.split('.')[1];
            let line: RecordLine = this.recordLine;
            if (index !== 0) {
              const lineId = maxIndex + index + 1;
              line = RecordLine.addNewLine(
                this.recordModel,
                this.section,
                lineId,
                this.moduleStructure.defaultValues,
                this.moduleStructure,
                this.layoutService,
              );
            }

            const data = response[key];
            if (this.recordModel.ObjectCode === '191') {
              serviceCall.setModuleHeaderData(data);
            }

            // const section = this.moduleStructure.module.Sections.find(
            //   (x) => x.XmlTagName === this.sectionTagName
            // );

            this.moduleStructure.module.Sections.filter(
              (x) => x.XmlTagName === this.sectionTagName,
            ).forEach((section) => {
              section.Fields.forEach((field) => {
                if (
                  field.LinkedModule === this.field.LinkedModule &&
                  this.field.LinkedModuleGroup === field.LinkedModuleGroup &&
                  (forceToField === '' ||
                    (forceToField !== '' &&
                      forceToField === field.PropertyName))
                ) {
                  const linkedFieldStr = GlobalObject.getLinkedModuleField(
                    linkedModule,
                    field.LinkedField,
                  );
                  // const value = d[field.LinkedField];
                  let value = data[linkedFieldStr];
                  const property = line.Properties.find(
                    (x) => x.Name === field.PropertyName,
                  );
                  if (property != null && value !== undefined) {
                    if (property.DataType === FieldDataType.Select) {
                      const option = property.Options?.find(
                        (op) => op.Code === value || op.DBValue === value,
                      );
                      if (option != null && option !== undefined) {
                        value = option.Code.toString();
                      }
                    } else if (property.DataType === FieldDataType.Date) {
                      value = moment(
                        value,
                        g.companyConfiguration.MomentDateFormat,
                      ).toDate();
                    }
                    property.ValueAsObject = value;
                    this.layoutService.triggerFieldValueChanged({
                      recordProperty: property,
                      formId: '',
                      line: line.Id,
                      recordModel: this.recordModel,
                      sectionTagName: this.sectionTagName,
                      moduleStructure: this.moduleStructure,
                      parentComponent: this.parent,
                    });
                  }
                } else {
                  const key = Object.keys(data).find(
                    (x) => x === field.PropertyName,
                  );
                  if (key != null) {
                    const property = line.Properties.find(
                      (x) => x.Name === field.PropertyName,
                    );
                    if (property) {
                      const structurProp = section.Fields.find(
                        (x) => x.PropertyName === property.Name,
                      );
                      if (
                        structurProp &&
                        structurProp.ParentProperties != null &&
                        structurProp.ParentProperties.includes(
                          this.field.PropertyName,
                        )
                      ) {
                        property.ValueAsObject = data[key];
                      }
                    }
                  }
                }
              });
            });
          });
        }),
        /*switchMap(() => {
          if (this.sectionTagName === 'Document_Lines') {
            const lines = this.recordCategory.Lines;
            const bomRecords = lines.filter(
              (x) =>
                x.TreeTypeProp !== null && x.TreeTypeProp.ValueAsObject !== 'N'
            );
            return BillOfMaterials.LoadBOMItems(
              bomRecords,
              this.bomService,
              this.moduleStructure,
              this.recordModel,
              this.layoutService
            );
          } else {
            return of(null);
          }
        })*/
      )
      .subscribe();
  }

  onKey(e) {
    const value = (e.target as HTMLInputElement).value;
    if (value != null && value !== undefined && value !== '') {
      return;
    }
    const linkedModuleInfo = this.getLinkedModuleInfo();

    if (linkedModuleInfo.IsById) {
      this.layoutService
        .moduleIdByType(
          linkedModuleInfo.LinkedModule,
          this.route.snapshot.data.app === 'crm' ? 'itm-crm' : '',
        )
        .subscribe((d) => {
          const moduleId = d.toString();
          this.layoutService
            .moduleInformation(moduleId)
            .subscribe((moduleInformation: ModuleInformation) => {
              this.moduleInformation = moduleInformation;
              if (this.moduleInformation.AuthorisedForList) {
                this.openSearchDrawer();
              }
            });
        });
    } else {
      const moduleId = linkedModuleInfo.LinkedModule;
      this.layoutService
        .moduleInformation(moduleId)
        .subscribe((d: ModuleInformation) => {
          this.moduleInformation = d;
          if (this.moduleInformation.AuthorisedForList) {
            this.openSearchDrawer();
          }
        });
    }
  }
}
